import produce from 'immer';

import { CardTab } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/CardTab/CardTab';
import { IActiveTab } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/TabsSection/TabsSection';
import { IProgramActivityPayload } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCardModal/ProgramActivityCardModal.types';
import { statusOptions } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/helper';
import { TabItem } from 'components/DesignSystem/Tabs';

export const tabsArrData: TabItem[] = [
    {
        value: 'cardDetails',
        label: 'Card Details',
    },
    {
        value: 'activityDetails',
        label: 'Activity Details',
    },
    {
        value: 'activityRelationships',
        label: 'Activity Relationships',
    },
    {
        value: 'relatedCards',
        label: 'Associated Activities',
    },
    {
        value: 'auditLogs',
        label: 'Audit Log',
    },
];

export const tabsArrDataMobile: TabItem[] = [
    {
        value: 'cardDetails',
        label: 'Card Details',
    },

    {
        value: 'activityRelationships',
        label: 'Activity Relationships',
    },

    {
        value: 'auditLogs',
        label: 'Audit Log',
    },
];

export const getStatusOptionsByCategory = (category, originalStatus) => {
    if (category && category.toLowerCase().includes('milestone')) {
        return produce(statusOptions, (draft) => {
            return draft
                .filter((item) => item.name !== 'IN_PROGRESS')
                .map((i) => {
                    return { ...i, originalStatus: originalStatus };
                });
        });
    }

    return statusOptions.map((i) => {
        return { ...i, originalStatus: originalStatus };
    });
};

export const buildProgramActivityCardPayload = (data): IProgramActivityPayload => {
    return {
        id: data.id,
        projectId: data.project.id,
        contractId: data.contract.id,
        activityId: data.activityId ? data.activityId.id : null,
        assigneeUserName: data.assignee.value,
        category: data.category.value,
        details: data.details,
        mentionedList: data.mentionedList,
        startDate: data.startDate,
        endDate: data.endDate,
        externalLinks: data.externalLinks,
        externalDocuments: data.externalDocuments,
        status: data.status.name,
        tagList: data.tagList.map((item) => ({ name: item.value })),
        title: data.title,
        relatedCardIds: null,
        type: data.type,
        isImportant: data.isImportant,
        versionId: data.versionId,
        remainingDurationInDays: data.remainingDurationInDays,
        submittedDurationComplete: data.submittedDurationComplete,
    };
};
